import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import HttpError from '../../../utils/fetch/errors/HttpError';
import { packageName, packageVersion } from './package-context';
import { recentWorkClientExperienceV2, recentWorkClientExperienceV3 } from './index';
export function fetchActivitiesWithExperience(_x, _x2) {
  return _fetchActivitiesWithExperience.apply(this, arguments);
}
function _fetchActivitiesWithExperience() {
  _fetchActivitiesWithExperience = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fetchActivities, clientVersion) {
    var experience, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          experience = clientVersion === 'v2' ? recentWorkClientExperienceV2() : recentWorkClientExperienceV3();
          _context.prev = 1;
          experience.start();
          experience.addMetadata({
            clientVersion: clientVersion,
            packageName: packageName,
            packageVersion: packageVersion
          });
          _context.next = 6;
          return fetchActivities(experience);
        case 6:
          data = _context.sent;
          experience.success();
          return _context.abrupt("return", data);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](1);
          experience.failure({
            metadata: {
              error: exceptionToMetadata(_context.t0)
            }
          });
          throw _context.t0;
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 11]]);
  }));
  return _fetchActivitiesWithExperience.apply(this, arguments);
}
export var exceptionToMetadata = function exceptionToMetadata(e) {
  if (e instanceof HttpError) {
    var _e$xRequestId;
    return _objectSpread(_objectSpread({}, e), {}, {
      xRequestId: (_e$xRequestId = e.xRequestId) !== null && _e$xRequestId !== void 0 ? _e$xRequestId : undefined,
      cause: undefined
    });
  }
  return e instanceof Error ? _objectSpread(_objectSpread({}, e), {}, {
    cause: undefined
  }) : 'unknown';
};